const peiAssistantsNeeds = {
  alimentacion: 1929,
  higiene: 1930,
  movilidad: 1932,
  transportacion: 1937,
  cateterizacion: 1992,
  colonostomia: 1995,
  gastrostomía: 1996,
  medicacion: 1997,
  medicacionV2: 3155,
  apoyoConductual: 2082,
  interpretacion: 3133,
  sillaDeRueda: 3143,
  ansiedadSevera: 3165,
};

export default peiAssistantsNeeds;
